<template>
	<form ref="form" class="wellness-form" :action="action" method="post" @submit="submit">
		<div class="row">
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="first_name"
						v-model="firstName"
						class="form-control"
						data-testid="input-first-name"
						maxlength="40"
						name="first_name"
						placeholder="First Name"
						type="text"
						v-bind="firstNameProps"
					/>
					<label for="first_name">First Name</label>
					<div class="invalid-feedback mt-1" data-testid="error-first-name">
						{{ errors.first_name }}
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="last_name"
						v-model="lastName"
						class="form-control"
						data-testid="input-last-name"
						maxlength="80"
						name="last_name"
						placeholder="Last Name"
						type="text"
						v-bind="lastNameProps"
					/>
					<label for="last_name">Last Name</label>
					<div class="invalid-feedback mt-1" data-testid="error-last-name">
						{{ errors.last_name }}
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="company"
						v-model="company"
						class="form-control"
						data-testid="input-company-name"
						name="company"
						placeholder="Company Name"
						type="text"
						v-bind="companyProps"
					/>
					<label for="company" class="">Company Name</label>
					<div class="invalid-feedback mt-1" data-testid="error-company-name">
						{{ errors.company }}
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<select
						id="selectstate"
						v-model="officeLocation"
						class="form-select"
						data-testid="input-office-location"
						name="00N40000001rTDW"
						v-bind="officeLocationProps"
					>
						<option :value="null" disabled>Select your location</option>
						<option
							v-for="location in officeLocations"
							:key="location.value"
							:value="location.value"
						>
							{{ location.label }}
						</option>
					</select>
					<label for="selectstate">Head Office Location</label>
					<div class="invalid-feedback mt-1" data-testid="error-office-location">
						{{ errors['00N40000001rTDW'] }}
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="employees"
						v-model="employees"
						name="employees"
						class="form-control"
						data-testid="input-employees"
						placeholder="Approximate Number of Employees"
						type="number"
						min="1"
						v-bind="employeesProps"
					/>
					<label for="employees">Approximate Number of Employees</label>
					<div class="invalid-feedback mt-1" data-testid="error-employees">
						{{ errors.employees }}
					</div>
				</div>
			</div>
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="title"
						v-model="title"
						name="title"
						class="form-control"
						data-testid="input-title"
						placeholder="Position Title"
						type="text"
						v-bind="titleProps"
					/>
					<label for="title">Position Title</label>
					<div class="invalid-feedback mt-1" data-testid="error-title">{{ errors.title }}</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<input
						id="phone"
						v-model="phone"
						v-maska="phoneMaskaOptions"
						name="phone"
						class="form-control"
						data-testid="input-phone"
						placeholder="Phone"
						type="tel"
						v-bind="phoneProps"
					/>
					<label for="phone">Phone</label>
					<div class="invalid-feedback mt-1" data-testid="error-phone">{{ errors.phone }}</div>
				</div>
			</div>
			<div class="col-lg-6 mb-2">
				<div class="form-floating">
					<input
						id="email"
						v-model="email"
						name="email"
						class="form-control"
						data-testid="input-email"
						maxlength="100"
						placeholder="Email"
						type="text"
						v-bind="emailProps"
					/>
					<label for="email">Email</label>
					<div class="invalid-feedback mt-1" data-testid="error-email">{{ errors.email }}</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-6">
				<div class="form-floating mb-2">
					<select
						id="clubs"
						v-model="club"
						class="form-select"
						data-testid="input-club"
						name="Club_of_Interest__c"
						v-bind="clubProps"
					>
						<option :value="null" disabled>Select your club</option>
						<option value="">None</option>
						<optgroup v-for="(group, index) in clubGroups" :key="index" :label="group.label">
							<option v-for="groupClub in group.clubs" :key="groupClub.id" :value="groupClub.id">
								{{ groupClub.clubTitle }}
							</option>
						</optgroup>
					</select>
					<label for="clubs">Club of Interest</label>
					<div class="invalid-feedback mt-1" data-testid="error-club">
						{{ errors.Club_of_Interest__c }}
					</div>
				</div>
			</div>
		</div>
		<div v-if="values['00N40000001rTDW'] === 'ON'" class="row">
			<div id="legal_consent">
				<div class="form-check mb-2">
					<input
						id="Legal_consent_acceptance"
						v-model="legal"
						class="form-check-input"
						data-testid="input-legal-consent"
						name="Legal_Copy_Version__c"
						type="checkbox"
						v-bind="legalProps"
					/>
					<label for="Legal_consent_acceptance" class="form-check-label mb-1">
						Yes, I would Like to receive emails from Life Time regarding products and services
						through the information provided above. I may opt-out of receiving communications from
						Life time at any time by clicking the unsubscribe link below.
					</label>
					<div class="invalid-feedback my-1" data-testid="error-legal-consent">
						{{ errors.Legal_Copy_Version__c }}
					</div>
					<div class="mb-2">
						<a href="/unsubscribe.html" target="_blank" class="link-underlined small">
							Unsubscribe
							<span class="visually-hidden">(external link)</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<div class="text-center pt-0">
			<button id="submitForm" class="btn btn-dark" data-testid="btn-submit" type="submit">
				Submit Form
			</button>

			<input type="hidden" name="oid" data-testid="input-oid" :value="authoredContent.oid" />
			<input type="hidden" name="retURL" data-testid="input-ret-url" :value="retUrl" />
			<input type="hidden" name="lead_source" data-testid="input-lead-source" value="LTF Website" />
			<input type="hidden" name="Lead_Origin__c" data-testid="input-lead-origin" value="AEM" />
			<input
				type="hidden"
				name="ltf_inquirytype"
				data-testid="input-inquiry-type"
				value="Corporate Sales"
			/>
			<input
				v-if="utmCampaign"
				id="00N0U000004EPB6"
				type="hidden"
				data-testid="input-utm-campaign"
				name="Utm_Campaign__c"
				:value="utmCampaign"
			/>
			<input
				v-if="utmSource"
				id="00N0U000004EPAw"
				type="hidden"
				data-testid="input-utm-source"
				name="Utm_Source__c"
				:value="utmSource"
			/>
			<input
				v-if="utmMedium"
				id="00N0U000004EPB1"
				type="hidden"
				data-testid="input-utm-medium"
				name="Utm_Medium__c"
				:value="utmMedium"
			/>
			<input
				v-if="utmContent"
				id="00N0U000004EPBB"
				type="hidden"
				data-testid="input-utm-content"
				name="Utm_Content__c"
				:value="utmContent"
			/>
			<input
				id="additionalData"
				class="d-none"
				ref="additionalData"
				type="text"
				data-testid="additional-data"
				name="additional-data"
				value=""
				tabindex="-1"
			/>
		</div>
	</form>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref, type Ref } from 'vue';
import { vMaska } from 'maska/vue';
import { useForm, type PublicPathState } from 'vee-validate';
import { useMaska } from '@/composables/use-maska';
import { aemServletService } from '@/services/aemServletService';
import { getAuthoredContent } from '@/util/getAuthoredContent';
import { sfWebToLead } from '@/util/configs';
import { logError, logWarn } from '@/util/logger';
import { getUtmParams } from '@/util/utm';
import { validateEmail, validateName, validatePhone } from '@/util/validators';
import type { AemuiClubState, WellnessForm } from 'Types/aemui/wellness-form/aemuiWellnessForm';
import type { SalesforceFormContent } from 'Types/aemui/salesforce-form-content/salesforceFormContent';

const action = sfWebToLead.url;
const form: Ref<HTMLFormElement | null> = ref(null);
const additionalData: Ref<HTMLInputElement | null> = ref(null);

const officeLocations = [
	{ value: 'ON', label: 'Canada' },
	{ value: 'AL', label: 'Alabama' },
	{ value: 'AK', label: 'Alaska' },
	{ value: 'AZ', label: 'Arizona' },
	{ value: 'AR', label: 'Arkansas' },
	{ value: 'CA', label: 'California' },
	{ value: 'CO', label: 'Colorado' },
	{ value: 'CT', label: 'Connecticut' },
	{ value: 'DE', label: 'Delaware' },
	{ value: 'DC', label: 'District Of Columbia' },
	{ value: 'FL', label: 'Florida' },
	{ value: 'GA', label: 'Georgia' },
	{ value: 'HI', label: 'Hawaii' },
	{ value: 'ID', label: 'Idaho' },
	{ value: 'IL', label: 'Illinois' },
	{ value: 'IN', label: 'Indiana' },
	{ value: 'IA', label: 'Iowa' },
	{ value: 'KS', label: 'Kansas' },
	{ value: 'KY', label: 'Kentucky' },
	{ value: 'LA', label: 'Louisiana' },
	{ value: 'ME', label: 'Maine' },
	{ value: 'MD', label: 'Maryland' },
	{ value: 'MA', label: 'Massachusetts' },
	{ value: 'MI', label: 'Michigan' },
	{ value: 'MN', label: 'Minnesota' },
	{ value: 'MS', label: 'Mississippi' },
	{ value: 'MO', label: 'Missouri' },
	{ value: 'MT', label: 'Montana' },
	{ value: 'NE', label: 'Nebraska' },
	{ value: 'NV', label: 'Nevada' },
	{ value: 'NH', label: 'New Hampshire' },
	{ value: 'NJ', label: 'New Jersey' },
	{ value: 'NM', label: 'New Mexico' },
	{ value: 'NY', label: 'New York' },
	{ value: 'NC', label: 'North Carolina' },
	{ value: 'ND', label: 'North Dakota' },
	{ value: 'OH', label: 'Ohio' },
	{ value: 'OK', label: 'Oklahoma' },
	{ value: 'OR', label: 'Oregon' },
	{ value: 'PA', label: 'Pennsylvania' },
	{ value: 'RI', label: 'Rhode Island' },
	{ value: 'SC', label: 'South Carolina' },
	{ value: 'SD', label: 'South Dakota' },
	{ value: 'TN', label: 'Tennessee' },
	{ value: 'TX', label: 'Texas' },
	{ value: 'UT', label: 'Utah' },
	{ value: 'VT', label: 'Vermont' },
	{ value: 'VA', label: 'Virginia' },
	{ value: 'WA', label: 'Washington' },
	{ value: 'WV', label: 'West Virginia' },
	{ value: 'WI', label: 'Wisconsin' },
	{ value: 'WY', label: 'Wyoming' }
];

const clubGroups: Ref<AemuiClubState[]> = ref([]);

const authoredContent: Ref<SalesforceFormContent> = ref({});
const utmCampaign = ref('');
const utmContent = ref('');
const utmMedium = ref('');
const utmSource = ref('');

onBeforeMount(async () => {
	authoredContent.value = getAuthoredContent<SalesforceFormContent>('aemuiWellnessFormScript');
	const utmParams = getUtmParams();
	utmCampaign.value = utmParams.utmCampaign;
	utmContent.value = utmParams.utmContent;
	utmMedium.value = utmParams.utmMedium;
	utmSource.value = utmParams.utmSource;
	try {
		const response = await aemServletService.getClubsByState();
		clubGroups.value = response.data;
	} catch (error: unknown) {
		logError('GET clubs by state', {}, error);
	}
});

const { defineField, errors, submitForm, values, validate } = useForm<WellnessForm>({
	initialValues: {
		'00N40000001rTDW': null,
		Club_of_Interest__c: null
	},
	validationSchema: {
		first_name: (value: string) => validateName(value, 'Please enter your first name', 40),
		last_name: (value: string) => validateName(value, 'Please enter your last name', 80),
		company: (value: string) => (value ? true : 'Please enter your corporate name'),
		'00N40000001rTDW': (value: string | null) =>
			value ? true : 'Please select your head office location',
		employees: (value: number | string) => {
			if (typeof value === 'string') {
				return 'Please enter a number';
			}
			return value > 0 ? true : 'Please enter approximate number of employees';
		},
		title: (value: string) => (value ? true : 'Please enter your position title'),
		phone: (value: string) => validatePhone(value, 'Please enter your phone number'),
		email: (value: string) => validateEmail(value, 'Please enter your email'),
		Legal_Copy_Version__c: (value: boolean) => {
			if (values['00N40000001rTDW'] !== 'ON') {
				return true;
			}
			return value ? true : 'This is a required field';
		}
	}
});

function propsHandler(state: PublicPathState, checkTouched = false) {
	const showError = checkTouched
		? state.touched && state.errors.length > 0
		: state.errors.length > 0;
	return { class: showError ? 'is-invalid' : '' };
}

const [firstName, firstNameProps] = defineField('first_name', {
	props: (state) => propsHandler(state)
});

const [lastName, lastNameProps] = defineField('last_name', {
	props: (state) => propsHandler(state)
});

const [company, companyProps] = defineField('company', {
	props: (state) => propsHandler(state)
});

const [officeLocation, officeLocationProps] = defineField('00N40000001rTDW', {
	props: (state) => propsHandler(state)
});

const [employees, employeesProps] = defineField('employees', {
	props: (state) => propsHandler(state)
});

const [title, titleProps] = defineField('title', {
	props: (state) => propsHandler(state)
});

const { phoneMaskaOptions } = useMaska();
const [phone, phoneProps] = defineField('phone', {
	props: (state) => propsHandler(state, true)
});

const [email, emailProps] = defineField('email', {
	props: (state) => propsHandler(state, true)
});

const [club, clubProps] = defineField('Club_of_Interest__c', {
	props: (state) => propsHandler(state)
});

const [legal, legalProps] = defineField('Legal_Copy_Version__c', {
	props: (state) => propsHandler(state)
});

const retUrl = computed(
	() =>
		authoredContent.value?.retUrl ??
		'https://www.lifetime.life/corporate-wellness/confirmation.html'
);

const submit = (e: Event) => {
	e.preventDefault();
	if (additionalData.value?.value) {
		window.location.assign(retUrl.value + '?success');
		logWarn('Corporate Wellness Form: additional data has a value', {
			values,
			additionalData: additionalData.value?.value
		});
	} else {
		submitForm(e);
	}
};

defineExpose({
	values,
	validate
});
</script>
